module.exports = __webpack_public_path__ + "static/media/plastic_trowel_1.94caacfc.svg";